export default __webpack_public_path__ + "static/brat_thumb-4663dafdc3cf42779ff431faca60f56f.jpg";